import { FC } from 'react';

import { AccountCircle } from '@mui/icons-material';
import { Typography, Grid, Box } from '@mui/material';

import { abbreviateNumber, isAddressFromPegaxyTeam } from '../../utils/humanizer';
import { Card } from '../atoms/Card';
import { PgxIcon } from '../layout/icons/pgx-icon';
import { TooltipCopy } from '../molecules/TooltipCopy';

interface ProposalVotesProps {
  votes: {
    userId: string;
    voteOption: string;
    netWorth: number;
    publicAddress: string;
  }[];
}

export const ProposalVotes: FC<ProposalVotesProps> = ({ votes }) => {
  return (
    <Card
      titleBoxColor="blue"
      title="Votes"
      titleBoxText={`${votes.length}`}
      sx={{
        height: '100%',
        maxHeight: '19rem',
        paddingRight: 0,
      }}
    >
      <Box
        sx={{
          height: '100%',
          overflowY: 'auto',
          pr: 3,
          maskImage:
            'linear-gradient(0deg, rgba(19, 22, 28, 0) 0%, rgb(19, 22, 28) 16%, rgb(19, 22, 28) 97%, rgba(19, 22, 28, 0) 100%)',
          '& > *:not(:last-child)': {},
        }}
      >
        {votes
          .sort((a, b) => {
            return b.netWorth - a.netWorth;
          })
          .map((vote) => (
            <Grid container spacing={2} sx={{ pb: 3 }}>
              <Grid item xs={4} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'start' }}>
                <AccountCircle sx={{ mr: 1, height: 18, width: 18 }} />
                <TooltipCopy
                  value={vote.publicAddress}
                  hiddeTooltip={isAddressFromPegaxyTeam(vote.publicAddress)}
                  placement="top"
                  sx={{ width: 'calc(100% - 18px)' }}
                >
                  <Typography
                    variant="body1"
                    sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                  >
                    {vote.publicAddress}
                  </Typography>
                </TooltipCopy>
              </Grid>
              <Grid item xs={4}>
                <Typography
                  variant="body1"
                  sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', textAlign: 'center' }}
                >
                  {vote.voteOption}
                </Typography>
              </Grid>
              <Grid item xs={4} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'end' }}>
                <Typography variant="body2" color="text.secondary">
                  {abbreviateNumber(vote.netWorth)}
                </Typography>
                <PgxIcon sx={{ height: 16, width: 16, ml: 1 }} />
              </Grid>
            </Grid>
          ))}
      </Box>
    </Card>
  );
};
